module.exports = __webpack_public_path__ + "static/media/bom.b01fe160.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bom.gif
// module id = 496
// module chunks = 0